<template>
  <div class="l-role-box">
    <div class="l-container-title">
      <i class="ri-organization-chart"></i><b>组织架构</b>
    </div>

    <div class="l-role-list-main" v-loading="loading">
      <el-tree ref="tree" :data="tree_data" node-key="id" default-expand-all highlight-current :expand-on-click-node="false" :current-node-key="select_id" @node-click="handleNodeClick">
        <div class="custom-tree-node" slot-scope="{ node, data }" @click="checkOrg(data.id)" @mouseover="show_action_id = data.id" @mouseleave="show_action_id = ''" style="width: 100%">
          <span :class="{ 'l-elipsis': select_id == data.id || show_action_id == data.id }">
            <i class="ri-building-2-fill" style="color: #409eff; font-size: 17px" v-show="data.type == 1"></i>
            <i class="ri-team-fill" style="color: #e6a23c; font-size: 17px" v-show="data.type == 2"></i>
            {{ node.label }}
          </span>
        </div>
      </el-tree>
    </div>
  </div>
</template>
<script>
export default {
  name: "l-applet-org-list",

  data() {
    return {
      loading: false,

      tree_data: [],
      select_id: null,
      show_action_id: null,

      add_visible: false,
      pid: "",

      edit_visible: false,
      edit_id: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取组织架构数据
    getList() {
      this.loading = true;
      this.$_invoke("uniOrg_getTree")
        .then((ret) => {
          this.tree_data = ret.tree_data;
          //如果未选中角色，则进行选中
          if (!this.select_id) {
            if (this.tree_data.length > 0) {
              this.checkOrg(this.tree_data[0].id);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //显示添加组织架构弹窗
    showAdd(pid) {
      this.pid = pid;
      this.add_visible = true;
    },

    //选中某个组织
    checkOrg(id) {
      //点击角色前的前置事件
      this.$emit("on-before-check");
      this.$nextTick(() => {
        this.select_id = id;
        this.$refs.tree.setCurrentKey(id);
        this.$emit("on-after-check", id);
      });
    },

    //添加成功回调
    onAddSuccess() {
      this.pid = "";
      this.add_visible = false;
      this.getList();
    },

    //显示编辑
    showEdit(id) {
      this.edit_id = id;
      this.edit_visible = true;
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_id = "";
      this.edit_visible = false;
      this.getList();
    },

    //删除
    del(id) {
      this.$confirm("确认删除该组织吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`uniOrg_delete`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },

    //点击节点
    handleNodeClick(data) {
      this.checkOrg(data.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.l-elipsis {
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
}
</style>
